module.exports = __webpack_public_path__ + "static/media/opakowania_2_A.04425ef1.png";